import React, { memo, PropsWithChildren, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Demo } from 'plume-ui';

import { DemoId } from './steps';
import getSteps from './steps';

const GlobalDemoContext = React.createContext({
  setDemoId: (demoId: DemoId) => {},
});

export const useGlobalDemo = () => React.useContext(GlobalDemoContext);

const GlobalDemoProvider = ({ children }: PropsWithChildren) => {
  const { t } = useTranslation();
  const [demoId, setDemoId] = useState<DemoId>(DemoId.None);

  const setDemo = (demoId: DemoId) => {
    if (process.env.CI || process.env.IS_PLAYWRIGHT) return;
    setDemoId(demoId);
  };

  return (
    <GlobalDemoContext.Provider value={{ setDemoId: setDemo }}>
      {children}
      {demoId && (
        <Demo
          skipLabel={t('demo.skip')}
          nextLabel={t('demo.next')}
          backLabel={t('demo.back')}
          finishLabel={t('demo.finish')}
          steps={getSteps(t)}
          demoId={demoId}
          elementWaitTime={10000}
        />
      )}
    </GlobalDemoContext.Provider>
  );
};

export default memo(GlobalDemoProvider);
